<template>
  <div class="w_header">
    <!-- Home顶部功能区域 -->
    <div class="site-nav" id="site-nav">
      <div class="w w1200">
        <ul class="quick-menu fl">
          <li @click="$router.push('/brand')">品牌馆</li>
          <li class="spacer"></li>
          <li @click="merchantSettleIn">商家入驻</li>
          <li class="spacer"></li>
          <li><i class="el-icon-phone"></i> HELLO:{{informations.consumerHotline}}</li>
          <li class="spacer"></li>
<!--          <li class="li_dorpdown">-->
<!--            <span @mouseenter="showapp = !showapp" @mouseleave="showapp = !showapp">-->
<!--              <i class="el-icon-mobile-phone"></i> APP下载-->
<!--              <i class="el-icon-arrow-down"></i>-->
<!--            </span>-->
<!--            &lt;!&ndash; 隐藏区域 &ndash;&gt;-->
<!--            <transition name="el-zoom-in-top">-->
<!--              <div v-show="showapp" class="dropdown-menu"-->
<!--                   style="z-index: 10000000; position: absolute; border-top: 2px solid #ff6700;">-->
<!--                <el-image :src="appImg" fit="fill" style="width: 160px; height: 160px">-->
<!--                  <div slot="error" class="image-slot">-->
<!--                    <i class="el-icon-picture-outline"></i>-->
<!--                  </div>-->
<!--                </el-image>-->
<!--              </div>-->
<!--            </transition>-->
<!--          </li>-->
          <li class="spacer"></li>
          <li>
            <span @mouseenter="showwx = !showwx" @mouseleave="showwx = !showwx">
              <i class="el-icon-mobile-phone"></i> 微商城
              <i class="el-icon-arrow-down"></i>
            </span>
            <!-- 隐藏区域 -->
            <transition name="el-zoom-in-top">
              <div v-show="showwx" class="dropdown-menu" style="
                  z-index: 10000000;
                  position: absolute;
                  border-top: 2px solid #ff6700;">
                <el-image :src="mpImg" fit="fill" style="width: 160px; height: 160px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </transition>
          </li>
          <li class="spacer"></li>
          <li>
            <div class="amap-page-container">
              <el-amap vid="amap" :plugin="plugin" class="amap-demo" :center="center"></el-amap>
              <div class="toolbar">
                <span v-if="loaded">
                  <i class="el-icon-location"></i> {{ city }}
                </span>
                <span v-else>正在定位</span>
              </div>
            </div>
          </li>
        </ul>
        <!-- <div class="fl">
          <div class="city-choice" id="city-choice" data-ectype="dorpdown">
            <div class="dsc-choie dsc-cm" ectype="dsc-choie">
              <img src="images/place.png" class="place" />
              <input type="text" value="全国" class="search" />
            </div>
          </div>
        </div> -->
        <ul class="quick-menu fr">
          <li v-if="isLogin">
            <el-popover
              placement="bottom"
              width="200"
              trigger="hover">
              <router-link tag="div" to="/userCenter" class="user-data clearfix">
                <el-image class="avatar" :src="userInfo.avatar || avatar" fit="contain"></el-image>
                <div class="user-data-info">
                  <div class="user-data-name">{{ userInfo.userName || userInfo.loginName }}</div>
                  <div class="user-data-out" @click.stop="rollOut">退出登录</div>
                </div>
              </router-link>
              <router-link to="/userCenter" slot="reference">{{ userInfo.userName || userInfo.loginName }}</router-link>
            </el-popover>
          </li>
          <template v-else>
            <li><router-link to="/login">登录</router-link></li>
            <li class="spacer"></li>
            <li><router-link to="/register">注册</router-link></li>
          </template>
          <li class="spacer"></li>
          <li><router-link to="/myOrderRight">我的订单</router-link></li>
          <li class="spacer"></li>
          <li><router-link to="/goodsCollection">我的收藏</router-link></li>
          <li class="spacer"></li>
          <li><router-link to="/articleList?type=2">帮助中心</router-link></li>
          <li class="spacer"></li>
          <li>
            <el-dropdown style="font-size: inherit">
              <span class="dt el-dropdown-link" style="cursor:pointer"> 站点导航</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link to="/siteNavigation">用户中心</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link to="/paymentCenter">支付中心</router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link to="/">网站首页</router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </div>
    <!-- logo+收索 -->
    <div class="w w1200">
      <div class="header-search" type="flex" justify="center" align="top">
        <img class="logo" @click="$router.push('/')" :src="logo" alt="腾信智慧" />
        <div class="search-box">
          <el-input :placeholder="hotSearchList[0]" v-model="searchInput" class="input-with-select" @keyup.enter.native="getSearchClick">
            <el-button type="primary" slot="append" icon="el-icon-search" @click="getSearchClick"></el-button>
          </el-input>
          <div class="hot-keyword-list">
            <template v-for="(item, index) in hotSearchList">
              <router-link class="hot-keyword" :to="`/goodsList?adWord=${item}`" :key="item">{{ item }}</router-link>
              <el-divider direction="vertical" v-if="index < hotSearchList.length - 1"></el-divider>
            </template>
          </div>
        </div>
        <el-button class="shopgoods" size="small" icon="el-icon-shopping-cart-1" @click="$router.push('/shoppingcart')">
          购物车 <el-badge class="mark" :value="cartSkus.length" />
        </el-button>
      </div>
    </div>
    <!-- 顶部菜单 -->
    <div class="w w1200" v-if="isShowNav">
      <div class="categorys">
        <div class="categorys-type"><i class="el-icon-menu"></i> 全部商品分类</div>
        <!-- 隐藏分类 -->
        <div class="categorys-tab-content">
          <div class="categorys-items" id="cata-nav">
            <!-- 商品分类start -->
            <div class="categorys-item" v-for="oneItem in categoryList" :key="oneItem.categoryOne.bxscId">
              <div class="item item-content">
                <i class="iconfont icon-ele">
                  <img :src="require('../assets/images/icon/elece.png')" style="vertical-align: baseline;"/>
                </i>
                <div class="categorys-title">
                  <strong>
                    <router-link :to="`/goodsList?bxscId=${oneItem.categoryOne.bxscId}&bxscName=${oneItem.categoryOne.name}`">
                      {{ oneItem.categoryOne.name }}
                    </router-link>
                  </strong>
                  <span>
                    <router-link :to="`/goodsList?bxscId=${subItem.category.bxscId}&bxscName=${subItem.category.name}`" v-for="subItem in oneItem.subItems.slice(0,2)" :key="subItem.category.bxscId">
                      {{ subItem.category.name }}
                    </router-link>
                  </span>
                </div>
              </div>
              <div class="categorys-items-layer">
                <div class="cate-layer-con clearfix">
                  <div class="cate-layer-left">
                    <div class="cate_channel">
                      <router-link :to="`/goodsList?bxscId=${subItem.category.bxscId}&bxscName=${subItem.category.name}`" v-for="subItem in oneItem.subItems.slice(0,6)" :key="subItem.category.bxscId">
                        {{ subItem.category.name }}
                      </router-link>
                    </div>
                    <div class="cate_detail">
                      <dl v-for="(subItem,index) in oneItem.subItems" :key="subItem.category.bxscId" :class="'dl_fore'+(index+1)">
                        <dt>
                          <router-link :to="`/goodsList?bxscId=${subItem.category.bxscId}&bxscName=${subItem.category.name}`">
                            {{ subItem.category.name }}
                          </router-link>
                        </dt>
                        <dd>
                          <router-link :to="`/goodsList?bxscId=${thrItem.bxscId}&bxscName=${thrItem.name}`" v-for="thrItem in subItem.sub" :key="thrItem.bxscId">
                            {{ thrItem.name }}
                          </router-link>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div v-if='oneItem.subItems.length===0' class="nodataCss">
                    <p>暂无相关分类数据</p>
                  </div>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-main">
        <el-menu :default-active="activeIndex"
                 class="el-menu-demo"
                 mode="horizontal"
                 active-text-color="currentColor"  @select="handleSelect">
          <template v-for="item in navList">
            <el-menu-item :index="item.navUrl" :key="item.navId">{{ item.navTitle }}</el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="../assets/js/kuCity.js"></script>
<script>
import mainlayout from "../components/layout/mainlayout";
import {navList, leftMenuList, hot_search, search_list} from "../api/xunyou";
export default {
  name: "topnav",
  inject: ['reload'],
  data() {
    let self = this;
    return {
      avatar: require('../assets/img/avatar.png'),
      showapp: false, //app不显示
      showwx: false, //微信不显示
      show2: false, //默认进入不显示
      collapsed: false,
      allmenu: [],
      //地图
      center: [121.59996, 31.197646],
      city: "全国",
      lng: 0,
      lat: 0,
      loaded: false,
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  self.$store.commit('gotCurrentAddress', result.addressComponent)
                  console.log(result, "|wb");
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.city = result.addressComponent.city;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  self.$nextTick();
                }
              });
            },
          },
        },
      ],
      navList: [],
      categoryList: [],
      hotSearchList: [],
      searchInput: ''
    };
  },
  components: {
    mainlayout,
  },
  computed: {
    mpImg () {
      return this.$store.state.staticPath + '/app/reg_wx.jpg'
    },
    appImg () {
      return this.$store.state.staticPath + '/app/dwd.png'
    },
    activeIndex () {
      return this.$route.fullPath;
    },
    isLogin () {
      return this.$store.getters.isLogin;
    },
    userInfo () {
      return this.$store.state.userInfo;
    },
    isShowNav() {
      return this.$store.state.isShowNav;
    },
    cartSkus() {
      return this.$store.getters.cartSkus;
    },
    logo () {
      return this.$store.state.logo;
    },
    accountTotal() {
      return this.$store.getters.accountTotal;
    },
    applyStoreState () {
      return this.$store.state.applyStoreData;
    },
    informations() {
      return this.$store.state.copyrights ||''
    }
  },
  created() {
    this.searchNavList();
    this.searchleftMenuList();
    this.gethotSearch();
  },
  methods: {
    // 商家入驻
    merchantSettleIn () {
      this.$tools.isLogin(() => {
        const arr = ['APPLY', 'AUDIT_ERR', 'PUBLICITY', 'WAIT_REFUND', 'CLOSE', 'CLOSE_REG'];
        const loading = this.$loading();
        this.$store.dispatch('getStoreData', () => {
          loading.close();
          if (this.applyStoreState) {
            if (arr.includes(this.applyStoreState.merchantStatus)) {
              this.$router.push('/settleIn/storeClose');
            } else if (this.applyStoreState.merchantStatus === 'PAID') {
              this.$router.push('/settleIn/storeOpen');
            } else {
              this.$router.push('/settleIn/merchantStatus');
            }
          } else {
            this.$router.push('/settleIn/welcomesystem');
          }
        });
      });
    },
    // 搜索点击
    getSearchClick(){
      if(!this.searchInput){
        this.searchInput = this.hotSearchList[0];
      }
      this.$router.push(`/goodsList?adWord=${this.searchInput}`);
    },
    // 退出登录
    rollOut() {
      this.$store.commit('logout');
      this.$router.push('/login');
    },
    // 顶部菜单
    searchNavList() {
      navList().then((res) => {
        console.log('菜单：', res);
        if (res.code === 0) {
          this.navList = res.data.filter(ele => {
            if (ele.navTitle === '批发市场') {
              return parseInt(this.userInfo.type) === 1; // 商户角色才显示批发市场
            } if (ele.navTitle === '商家店铺') {
              return this.$store.getters.isMerchant;
            } else {
              return true;
            }
          });
        }
      }).catch((err) => {
        this.$message.error("加载失败，请稍后再试！");
      });
    },
    // 左侧菜单
    searchleftMenuList() {
      leftMenuList().then((res) => {
        console.log('左侧菜单列表：', res);
        if (res.code === 0) {
          this.categoryList = res.data;
        }
      }).catch((err) => {
        this.$message.error("加载失败，请稍后再试！");
      });
    },

    handleSelect(key, keyPath) {
      if (this.$route.fullPath === key) return ;
      if (key && key.indexOf('http') > -1) {
        window.location.href = key;
      } else {
        this.$router.push(key);
      }
    },

    // 热门搜索
    gethotSearch() {
      hot_search().then((res) => {
        console.log('热门搜索：', res);
        if (res.code === 0) {
          this.hotSearchList = res.data.column10.split(',');
        }
      })
      .catch((err) => {
        this.$message.error("加载失败，请稍后再试！");
      });
    },
    // 默认搜索
    getSearchList() {
      search_list().then((res) => {
        console.log('默认搜索', res);
        if (res.code === 0) {
          this.searchInput = res.rows[0].column1;
        }
      })
      .catch((err) => {
        this.$message.error("加载失败，请稍后再试！");
      });
    },
  }
};
</script>
<style lang="less" scoped>
.user-data{
  cursor: pointer;
  color: #888888;
  .avatar{
    width: 60px;
    height: 60px;
    float: left;
    border-radius: 50%;
    margin-right: 10px;
    border: 1px solid #ECECEC;
  }
  .user-data-name{
    color: #333333;
    font-weight: 500;
    margin-top: 10px;
  }
  .user-data-out{
    font-size: 12px;
    margin-top: 5px;
    padding: 5px 0;
  }
  &:hover{
    color: var(--main-theme-color);
  }
}
.w_header{
  background-color: #fff;
  .logo{
    height: 68px;
  }
}
.input-with-select{
  margin-bottom: 10px;
  /deep/ .el-input__inner,
  /deep/ .el-input-group__append{
    border: 2px solid var(--main-theme-color);
  }
  /deep/ .el-input-group__append{
    background-color: var(--main-theme-color);
    color: #fff;
  }
}
.header-search{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 30px 0;
  text-align: left;
  .search-box{
    width: 650px;
  }
}

/* 购物车样式 */
.shopgoods{
  border: 2px solid var(--main-theme-color);
  color: var(--main-theme-color);
  padding: 7px 15px;
}

/* top菜单 */
.categorys {
  position: relative;
  float: left;
  width: 232px;
  height: 40px;
  &:hover > .categorys-tab-content,
  &:focus > .categorys-tab-content{
    z-index: 30;
    opacity: 1;
    max-height: 1000px;
    transition: opacity 0.1s linear, max-height 0.3s ease-in;
  }
}

.categorys-type {
  background-color: var(--main-theme-color);
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
}

.nav-main {
  float: left;
  width: 968px;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  color: var(--main-theme-color);
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 40px;
  line-height: 40px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #909399;
}

/* 分类表 */
.categorys-tab-content {
  display: block;
  position: relative;
  height: auto !important;
  padding: 15px 0;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.6);
  max-height: 0;
  opacity: 0;
  z-index: -1;
  transition: opacity 0.1s linear, max-height 0.3s ease-in;
}

.categorys-tab-content .categorys-items {
  position: relative;
  height: 100%;
}

.categorys-tab-content .categorys-item {
  cursor: pointer;
  height: 14.29%;
}

.categorys-tab-content .item-content {
  padding: 5px 16px;
  float: left;
  width: 200px;
}

.categorys-tab-content .item-content .icon-other {
  float: left;
  width: 18px;
  height: 18px;
}

.categorys-tab-content .item-content .icon-other img {
  width: 100%;
}

.categorys-tab-content .selected .item-content {
  background-color: rgba(0, 0, 0, 1);
}

.categorys-tab-content .iconfont {
  float: left;
  color: #bfbfbf;
}

.categorys-tab-content .categorys-title {
  float: left;
  margin-left: 10px;
  text-align: left;
}

.categorys-tab-content .categorys-title strong {
  display: block;
  font-weight: normal;
}

.categorys-tab-content .categorys-title strong a {
  color: #fff;
  font-size: 14px;
}

.categorys-tab-content .categorys-title span {
  display: block;
  font-size: 0;
}

.categorys-tab-content .categorys-title span a {
  color: #bfbfbf;
  margin-right: 10px;
  font-size: 14px;
}

.categorys-tab-content .categorys-title span a:hover,
.categorys-tab-content .categorys-title strong a:hover {
  color: var(--main-theme-color);
}
.categorys-tab-content .categorys-item:hover .categorys-items-layer {
  display: block;
}

.categorys-items-layer {
  display: none;
  position: absolute;
  top: 0;
  left: 232px;
  width: 966px;
  min-height: 498px;
  border: 1px solid #fff;
  background-color: #fff;
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, .1);
  -webkit-transition: top .25s ease;
  transition: top .25s ease;

  .nodataCss {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/topnav.vue